<template>
    <v-sheet class="ma-0 py-4 pl-4 pr-2" rounded="lg">
        <v-row class="pa-0 align-center" no-gutters>
            <span v-if="sltClcd == '1'" class="font-weight-medium fontOneToTwo">주간 → 야간</span>
            <span v-else-if="sltClcd == '2'" class="font-weight-medium fontOneToTwo">야간 → 주간</span>
            <span class="font-weight-medium fontOneToTwo">&nbsp;인계사항내역</span>
            <v-spacer></v-spacer>
            <v-btn
                @click="$emit('offMdl', true)"
                style="margin-top: 2px;" icon>
                <v-icon class="grey006--text" size="30">mdi-close</v-icon>
            </v-btn>
        </v-row>
        <v-divider class="mr-2 mt-2"></v-divider>
        <v-row class="pa-0 mr-2" no-gutters>
            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR py-1" cols="3">
                <span class="font-weight-medium">인계일</span>
            </v-col>
            <v-col class="tableBR px-1" style="padding-top: 2px;" cols="4">
                <span class="fontDotEight">{{ bscsInfo.tkeDt }}</span>
            </v-col>
            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR tableBR py-1" cols="3">
                <span class="font-weight-medium">총건수</span>
            </v-col>
            <v-col class="px-1" style="padding-top: 2px;" cols="2">
                <span class="fontDotEight"> {{ tkeOvrList.length }}건</span>
            </v-col>
        </v-row>
        <v-divider class="mr-2"></v-divider>
        <v-divider class="mr-2 mt-2"></v-divider>
        <v-row class="nmlBfClr-grey001 pa-0 mr-2" no-gutters>
            <v-col class="txtAlgnMid tableBR py-1" cols="2">
                <span class="font-weight-medium">연번</span>
            </v-col>
            <v-col class="txtAlgnMid tableBR py-1" cols="7">
                <span class="font-weight-medium">인계사항</span>
            </v-col>
            <v-col class="txtAlgnMid py-1" cols="3">
                <span class="font-weight-medium">처리</span>
            </v-col>
        </v-row>
        <v-divider class="mr-2"></v-divider>
        <div
            v-if="tkeOvrList.length > 0"
            class="d-inline-block overflow-y-auto pr-2"
            :style="{ 'width': '100%', 'height': ($vuetify.breakpoint.height - 291) + 'px' }">
             <v-row
                class="pa-0 tableBB"
                v-for="(lst, i) in tkeOvrList" :key="i"
                no-gutters>
                <v-col class="txtAlgnMid tableBR" style="padding-top: 14px;" cols="2">
                    <span class="fontDotEight">{{ i + 1 }}</span>
                </v-col>
                <v-col class="tableBR" cols="7">
                    <div
                        class="d-inline-block overflow-y-auto fontDotSeven mx-1"
                        style="width: 95%; height: 50px; line-height: 1; word-break: break-all;">
                        {{ $moment(lst.wrtDtlDt, 'YYYYMMDD').format('YYYY.MM.DD') }}
                        {{ lst.wrtTmHh + ':' + lst.wrtTmMm }}
                        ({{ lst.wrtr }})
                        <br>
                        {{ lst.cntnt }}
                    </div>
                </v-col>
                <v-col class="txtAlgnMid" style="padding-top: 13px;" cols="3">
                    <v-btn
                        class="blue104 white--text"
                        min-width="47" max-width="53" height="28" :ripple="false"
                        style="padding: 0px 8px 1px 8px;"
                        @click="$parent.$parent.$parent.$parent.onHndOvrSavMdl(lst.tkeOvrPk)"
                        small outlined>
                        <span class="fontDotEight">조회</span>
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <v-row v-else class="pa-0 tableBB" no-gutters>
            <v-col class="txtAlgnMid pa-2" cols="12">
                <span class="fontDotEight">※ 조회된 목록이 없습니다.</span>
            </v-col>
        </v-row>

        <v-divider class="white mb-3"></v-divider>
        <v-row class="pa-0 justify-center" no-gutters>
            <v-btn
                :class="[savBtn ? '' : 'blue001 white--text']"
                @click="$parent.$parent.$parent.$parent.onHndOvrSavMdl(0)" :disabled="savBtn"
                outlined rounded small>
                <v-icon class="mr-1" size="18">mdi-content-save-outline</v-icon>
                <span v-if="sltClcd == '1'" class="fontDotEight" style="padding-bottom: 1px;">주간 → 야간</span>
                <span v-else-if="sltClcd == '2'" class="fontDotEight" style="padding-bottom: 1px;">야간 → 주간</span>
                <span class="fontDotEight mr-1" style="padding-bottom: 1px;">인계사항 신규 작성</span>
            </v-btn>
        </v-row>
    </v-sheet>
</template>

<script>
import { http } from '@/assets/js/baseAxios';

export default {
    name: 'HndOvrMdl',

    props : {
        sltYMD: { type: String, default: '' },
        sltClcd: { type: Number, default: 0 }
    },
            
    components: {
      
    },

    created: function(){
  
    },
    
    mounted: function(){
        //돔 로딩이 끝난 후 작업
        this.$nextTick(function () {
            if( this.sltYMD != '' && this.sltClcd != 0 ){
                switch (this.sltClcd) {
                    case 1:
                        this.bscsInfo.tkeDt = this.$moment(this.sltYMD, 'YYYYMMDD').format('YYYY.MM.DD')
                        break;
                    case 2:
                        this.bscsInfo.tkeDt = this.$moment(this.sltYMD, 'YYYYMMDD').add(1, 'days').format('YYYY.MM.DD')
                        break;
                    default:
                        break;
                }

                this.getTkeOvr(this.sltYMD, this.sltClcd)
            }
        })
    },

    computed: {

    },

    watch:{
     
    },

    methods: { 
        // 인수인계 목록 조회
        getTkeOvr: function (ymd, clcd){
            let obj = {}
            obj.inqYMD = ymd
            obj.clcd = clcd
       
            http.post('empApp/selTkeOvrList', obj)
                .then((response) => ( this.tkeOvrRst(response.data) ))
                .catch((error) => console.log('axios error /empApp/selTkeOvrList : ' + error))
        },

        tkeOvrRst: function (res){
            if(res.statusCode == 200)
                this.tkeOvrList = res.data

            this.savBtn = false
        },
    },
    
    data: () => ({
        savBtn: true,
        tkeOvrList: [],
        bscsInfo: { tkeDt: '', },
    }),
};
</script>